import { memo } from 'react';
import cn from 'classnames';
import { Box, Element, Image } from 'src/components';
import { IPublisher, ISection } from 'src/interface';
import { TitleWrap } from 'src/modules/shared/components/TitleWrap';
import RouterLink from 'src/components/links';
import styles from './style.module.scss';
import useInView from 'src/hooks/useInView';

interface IProps extends ISection<IPublisher> {}

export function PublisherSection({ items, title }: IProps) {
    const itemList = [...items, ...items];
    const [inViewRef, inView] = useInView({ rootMargin: '50px' });

    return (
        <Element className={styles['publisher-box']} domRef={inViewRef}>
            <TitleWrap
                className="text-[1.1rem] text-[#adb5bd]"
                title={title}
                renderAs="h2"
            />
            <Box
                className={cn(
                    'relative',
                    'text-[1rem] leading-[28px] text-center',
                    'h-[65px]',
                    'px-[1px] py-[5px]',
                    'overflow-hidden'
                )}
            >
                <Element
                    className={cn(
                        styles['publisher-wrapper'],
                        'absolute flex',
                        'animate-[bannermove_70s_linear_infinite]',
                        {
                            ['[animation-play-state:paused]']: !inView,
                        }
                    )}
                >
                    {itemList?.map((item: IPublisher, index: number) => {
                        return (
                            <RouterLink
                                key={index}
                                to={item.url}
                                className={styles['publisher-item']}
                                newTab={true}
                            >
                                <Image
                                    src={item.logo}
                                    alt={item.name}
                                    width={item.width}
                                    height={item.height}
                                />
                            </RouterLink>
                        );
                    })}
                </Element>
            </Box>
        </Element>
    );
}

export default memo(PublisherSection);
